import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
  InputLabel,
  Chip,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  generateAndExecuteMutation,
  generateMutation,
  graphqlMutation,
  graphqlQuery,
  createCaseDynamic,
  fetchDataEngine,
} from "../../data/Axios/DynamicService";
import {
  caseManagementUrl,
  clientManagementUrl,
  setupManagementUrl,
  userManagementUrl,
} from "../../config";
import {
  caseCategory,
  caseStatus,
  caseSubCategory,
  allUsersQuery,
  allCaseStatusesQuery,
} from "../../data/Axios/queries";
import { useEffect, useState } from "react";
import Header from "../../components/Header";

const base_url = caseManagementUrl.uri;
const userbase_url = userManagementUrl.uri;
const setup_baseurl = setupManagementUrl.uri;
const client_baseurl = clientManagementUrl.uri;

const CasesForm = (props) => {
  const [individualclientData, setindividualclientData] = useState([]);
  const [CorporateData, setCorporateData] = useState([]);
  const [caseCategoryData, setCaseCategoryData] = useState([]);
  const [caseSubCategoryData, setCaseSubCaseCategoryData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCorporateClient, setShowCorporateClient] = useState(false);
  const [showIndividualClient, setShowIndividualClient] = useState(false);
  const [caseStatusOptions, setCaseStatusOptions] = useState([]);
  const mapCaseStatusToFlag = (caseStatus) => {
    const statusMap = {
      Opened: 1,
      "In Progress": 2,
      Pending: 3,
      "On Hold": 4,
      Close: 5,
    };
    return statusMap[caseStatus] || 1;
  };

  const initialValues = {
    clientType: props.data ? props.data.clientTypeId : "",
    clientId: props.data ? props.data.clientId : "",
    caseNumber: props.data ? props.data.caseNumber : "",
    title: props.data ? props.data.title : "",
    caseCategoryId: props.data ? props.data.caseCategoryId : "",
    caseSubcategoryId: props.data ? props.data.caseSubCategoryId : "",
    description: props.data ? props.data.description : "",
    summary: props.data ? props.data.summary : "",
    statusFlag: props.data ? parseInt(props.data.statusFlag) : 0,
    fileNumber: props.data ? props.data.fileNumber : "",
    assignedAdvocate: props.data ? props.data.assignedAdvocate : "",
    associates: props.data && props.data.associates 
    ? props.data.associates
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter(id => !isNaN(id)) // Additional safety to filter out NaN values
    : [],
  };
  console.log("Props Data:",props.data)

  const caseCategoryOptions = caseCategoryData
    ? caseCategoryData.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.categoryName,
      }))
    : [];

  const caseSubcategoryOptions = caseSubCategoryData
    ? caseSubCategoryData.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.subcategoryName,
      }))
    : [];

  const IndividualclientOptions = individualclientData
    ? individualclientData.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.fullName,
      }))
    : [];

  const corporateclientOptions = CorporateData
    ? CorporateData.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.companyName,
      }))
    : [];

  // Helper: return true if a name segment looks like a real human name
  // (letters, spaces, hyphens, apostrophes, dots — no base64 / JWT garbage)
  const isValidName = (name) => {
    if (!name || typeof name !== "string") return false;
    const trimmed = name.trim();
    if (trimmed.length === 0) return false;
    // Reject strings that contain digits mixed with long runs of uppercase+lowercase (base64/JWT pattern)
    // or strings longer than 60 chars (no realistic name is that long)
    if (trimmed.length > 60) return false;
    // Allow only: letters (any script), spaces, hyphens, apostrophes, dots
    return /^[\p{L}\s'\-.]+$/u.test(trimmed);
  };

  const userOptions = usersData
    ? usersData
        .filter((data) => isValidName(data.firstName) || isValidName(data.lastName))
        .map((data) => ({
          value: data.id,
          label: [data.firstName, data.lastName]
            .filter(isValidName)
            .join(" ")
            .trim() || data.username || `User #${data.id}`,
        }))
    : [];

  // const caseStatusOptions = [
  //   { value: 1, label: "Opened" },
  //   { value: 2, label: "In Progress" },
  //   { value: 3, label: "Pending" },
  //   { value: 4, label: "On Hold" },
  //   { value: 5, label: "close" },
  // ];

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const validationSchema = yup.object().shape({
    clientType: yup.number().required("Client Type is required"),
    clientId: yup.number().required("Client ID is required"),
    caseNumber: yup.string().required("Case Number is required"),
    title: yup.string().required("Title is required"),
    caseCategoryId: yup.string().required("Case Category Id is required"),
    caseSubcategoryId: yup.string().required("Case Subcategory is required"),
    statusFlag: yup.string().required("Case Status is required"),
    assignedAdvocate: yup.string().required("Assigned Advocate is required"),
    associates: yup
      .array()
      .of(yup.number())
      .min(1, "Select at least one associate"),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");

  // Fetch case categories
  useEffect(() => {
    async function fetchCaseCategories() {
      try {
        const allcaseCategory = await graphqlQuery(caseCategory, base_url);
        if (allcaseCategory) {
          setCaseCategoryData(allcaseCategory);
        }
      } catch (error) {
        console.error("Error fetching case categories:", error);
      }
    }
    fetchCaseCategories();
  }, []);


   useEffect(() => {
    async function fetchCaseStatus() {
      try {
        const CaseStatus = await graphqlQuery(caseStatus, caseManagementUrl.uri);
        if (CaseStatus) {
          setCaseStatusOptions(CaseStatus);
        }
      } catch (error) {
        console.error("Error fetching Case Status Options:", error);
      }
    }
    fetchCaseStatus();
  }, []);

  // Fetch individual clients
  useEffect(() => {
    async function fetchIndividualClients() {
      try {
        const returnFields = ["id", "fullName"];
        const inputFields = { isActive: 1 };
        const Facts = await fetchDataEngine(
          "allIndividualClients",
          "clientModel",
          inputFields,
          returnFields,
          clientManagementUrl.uri
        );
        setindividualclientData(Facts);
      } catch (error) {
        console.error("Error fetching individual clients:", error);
      }
    }
    fetchIndividualClients();
  }, []);

  // Fetch corporate clients
  useEffect(() => {
    async function fetchCorporateClients() {
      try {
        const returnFields = ["id", "companyName"];
        const inputFields = { isActive: 1 };
        const Facts = await fetchDataEngine(
          "allCorporateClients",
          "clientModel",
          inputFields,
          returnFields,
          clientManagementUrl.uri
        );
        setCorporateData(Facts);
      } catch (error) {
        console.error("Error fetching corporate clients:", error);
      }
    }
    fetchCorporateClients();
  }, []);

  // Fetch all users/advocates
  useEffect(() => {
    async function fetchAllUsers() {
      try {
        const allUsersData = await graphqlQuery(allUsersQuery, userbase_url);
        if (allUsersData) {
          setUsersData(allUsersData);
          console.log("Users loaded:", allUsersData);
        }
      } catch (error) {
        console.error("Error fetching advocates/users:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllUsers();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      
      const {
        clientType,
        clientId,
        caseNumber,
        summary,
        caseSubcategoryId,
        title,
        description,
        caseCategoryId,
        statusFlag,
        fileNumber,
        assignedAdvocate,
      } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data?.id,
            clientType,
            clientId,
            caseNumber,
            summary,
            title,
            description,
            caseCategoryId,
            caseSubcategoryId,
            statusFlag,
            fileNumber,
            assignedAdvocate,
            associates: Array.isArray(values.associates)
              ? values.associates.join(",")
              : values.associates,
            updatedBy: userId,
          }
        : {
            clientType,
            clientId,
            caseNumber,
            summary,
            title,
            description,
            caseCategoryId,
            caseSubcategoryId,
            statusFlag,
            fileNumber,
            assignedAdvocate,
            associates: Array.isArray(values.associates)
                  ? values.associates.join(",")
                  : values.associates,
            createdBy: userId,
          };

      console.log("Editing?", props.isEditing);
      console.log("Mutation data:", mutationData);

      let response;
      try {
        if (props.isEditing) {
          response = await generateAndExecuteMutation(
            "updateCaseDynamic",
            mutationData,
            "newCase",
            base_url
          );
        } else {
          response = await generateAndExecuteMutation(
            "createCaseDynamic",
            mutationData,
            "newCase",
            base_url
          );
        }
        console.log("GraphQL response:", response);
        } catch (gqlErr) {
         // surface GraphQL error details returned by axios
          console.error("GraphQL execution error:", gqlErr);
          console.error("GraphQL response data:", gqlErr?.response?.data || gqlErr);
          throw gqlErr;
        }       

      if (response) {
        props.onAction();
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Case ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (props.isEditing && props.data) {
      handleCategoryChange(props.data.caseCategoryId);
      handleClientTypeChange(props.data.clientTypeId);
    }
  }, [props.isEditing, props.data]);

  async function handleCategoryChange(category) {
    const returnFields = ["id", "subcategoryName"];
    const inputFields = {
      categoryId: category,
    };
    const subcategories = await fetchDataEngine(
      "allCaseSubcategoriesByColumnValues",
      "caseSubcategoryModel",
      inputFields,
      returnFields,
      base_url
    );
    if (subcategories) {
      setCaseSubCaseCategoryData(subcategories);
    }
  }

  async function handleClientTypeChange(clientType) {
    if (clientType === 1) {
      setShowIndividualClient(true);
      setShowCorporateClient(false);
    } else {
      setShowCorporateClient(true);
      setShowIndividualClient(false);
    }
  }

  const clientTypeOptions = [
    {
      value: 1,
      label: "Individual",
    },
    {
      value: 2,
      label: "Corporate",
    },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Case" : "Create Case"}
        subtitle={
          props.isEditing ? "Edit an Existing Case" : "Create a New Case"
        }
      />

      <Formik
        enableReinitialize
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => {
          const filteredAdvocateOptions = userOptions.filter(
            (option) => !values.associates?.includes(option.value)
          );
          const filteredAssociateOptions = userOptions.filter(
            (option) =>
              option.value !== values.assignedAdvocate &&
              !values.associates?.includes(option.value)
          );

          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Title *"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.title}
                  name="title"
                  error={touched.title && !!errors.title}
                  helperText={touched.title && errors.title}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Reference Number *"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.caseNumber}
                  name="caseNumber"
                  error={touched.caseNumber && !!errors.caseNumber}
                  helperText={touched.caseNumber && errors.caseNumber}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description *"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.description}
                  name="description"
                  error={touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Summary *"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.summary}
                  name="summary"
                  error={touched.summary && !!errors.summary}
                  helperText={touched.summary && errors.summary}
                  multiline
                  rows={4}
                  sx={{ gridColumn: "span 2" }}
                />

                <Select
                  fullWidth
                  variant="filled"
                  value={values.clientType}
                  name="clientType"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    handleClientTypeChange(e.target.value);
                  }}
                  error={touched.clientType && !!errors.clientType}
                  sx={{ gridColumn: "span 2" }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Client Type
                  </MenuItem>
                  {clientTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>

                {showIndividualClient && !showCorporateClient && (
                  <Autocomplete
                    options={IndividualclientOptions}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Individual Clients"
                        variant="filled"
                        error={touched.clientId && !!errors.clientId}
                        helperText={touched.clientId && errors.clientId}
                        onBlur={handleBlur}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFieldValue("clientId", newValue ? newValue.value : "");
                    }}
                    value={
                      IndividualclientOptions.find(
                        (option) => option.value === values.clientId
                      ) || null
                    }
                    sx={{ gridColumn: "span 2" }}
                  />
                )}

                {showCorporateClient && !showIndividualClient && (
                  <Autocomplete
                    options={corporateclientOptions}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Corporate Clients"
                        variant="filled"
                        error={touched.clientId && !!errors.clientId}
                        helperText={touched.clientId && errors.clientId}
                        onBlur={handleBlur}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFieldValue("clientId", newValue ? newValue.value : "");
                    }}
                    value={
                      corporateclientOptions.find(
                        (option) => option.value === values.clientId
                      ) || null
                    }
                    sx={{ gridColumn: "span 2" }}
                  />
                )}

                <Select
                  fullWidth
                  variant="filled"
                  value={values.caseCategoryId}
                  name="caseCategoryId"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    handleCategoryChange(e.target.value);
                  }}
                  error={touched.caseCategoryId && !!errors.caseCategoryId}
                  sx={{ gridColumn: "span 2" }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Case Category
                  </MenuItem>
                  {caseCategoryOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  fullWidth
                  variant="filled"
                  label="Case Subcategory *"
                  value={values.caseSubcategoryId}
                  name="caseSubcategoryId"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={touched.caseSubcategoryId && !!errors.caseSubcategoryId}
                  sx={{ gridColumn: "span 2" }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Case Subcategory
                  </MenuItem>
                  {caseSubcategoryOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
{/* 
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="File Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.fileNumber}
                  name="fileNumber"
                  error={touched.fileNumber && !!errors.fileNumber}
                  helperText={touched.fileNumber && errors.fileNumber}
                  sx={{ gridColumn: "span 2" }}
                /> */}

                <Box sx={{ gridColumn: "span 2" }}>
                  <InputLabel>Assigned Advocate *</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    value={values.assignedAdvocate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="assignedAdvocate"
                    error={
                      touched.assignedAdvocate && !!errors.assignedAdvocate
                    }
                    helperText={
                      touched.assignedAdvocate && errors.assignedAdvocate
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Assigned Advocate
                    </MenuItem>
                    {filteredAdvocateOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                <Box sx={{ gridColumn: "span 2" }}>
                  <InputLabel>Associates *</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    multiple
                    value={values.associates || []}                    
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="associates"
                    error={touched.associates && !!errors.associates}
                    helperText={touched.associates && errors.associates}
                    displayEmpty
                    renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip
                        key={value}
                        label={
                          userOptions.find((opt) => opt.value === value)
                          ?.label
                        }
                        size="small"
                        onDelete={(e) => {
                          e.stopPropagation();
                          const newAssociates = values.associates.filter(
                            (id) => id !== value
                          );
                          setFieldValue("associates", newAssociates);
                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                        }}
                        />
                        ))}
                        </Box>
                        )}
                        >
                    {filteredAssociateOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                <Box sx={{ gridColumn: "span 2" }}>
                  <InputLabel>Case Status *</InputLabel>
                  <Select
                    fullWidth
                    variant="filled"
                    value={values.statusFlag}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="statusFlag"
                    error={touched.statusFlag && !!errors.statusFlag}
                    helperText={touched.statusFlag && errors.statusFlag}
                  >
                    {caseStatusOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.status}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </Box>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default CasesForm;